/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { getRiskList } from '../fn/safety-risk-controller/get-risk-list';
import { GetRiskList$Params } from '../fn/safety-risk-controller/get-risk-list';
import { ResponseSafetyRiskDto } from '../models/response-safety-risk-dto';

@Injectable({ providedIn: 'root' })
export class SafetyRiskControllerService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getRiskList()` */
  static readonly GetRiskListPath = '/safetyRisks';

  /**
   * Get safety risk list for all customers of an employee, supports IFilter
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getRiskList()` instead.
   *
   * This method doesn't expect any request body.
   */
  getRiskList$Response(params?: GetRiskList$Params, context?: HttpContext): Observable<StrictHttpResponse<ResponseSafetyRiskDto>> {
    return getRiskList(this.http, this.rootUrl, params, context);
  }

  /**
   * Get safety risk list for all customers of an employee, supports IFilter
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getRiskList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getRiskList(params?: GetRiskList$Params, context?: HttpContext): Observable<ResponseSafetyRiskDto> {
    return this.getRiskList$Response(params, context).pipe(
      map((r: StrictHttpResponse<ResponseSafetyRiskDto>): ResponseSafetyRiskDto => r.body)
    );
  }

}
